import { render, staticRenderFns } from "./GamesTab.vue?vue&type=template&id=316a9032&scoped=true&"
import script from "./GamesTab.vue?vue&type=script&lang=js&"
export * from "./GamesTab.vue?vue&type=script&lang=js&"
import style0 from "./GamesTab.vue?vue&type=style&index=0&id=316a9032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316a9032",
  null
  
)

export default component.exports